import Container from '@ui/container/container';
import AudiencesStatsCard from './audiences-stats-card';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import getThemeColorCSSVariable from '@/utils/colors/get-theme-color-css-variable';
import { useLoadEventRegistrantCounts } from '../hooks/use-load-event-registrant-counts';

function formatRate(numerator: number, denominator: number): string {
  if (!denominator) return '—';
  return `${Math.round((numerator / denominator) * 100)}%`;
}

const AudiencesStatsRow = () => {
  const { counts, loading } = useLoadEventRegistrantCounts();
  const iconColor = getThemeColorCSSVariable();

  return (
    <Container className="flex fd-row gap-20 margin-b-16">
      <AudiencesStatsCard
        title="Total Profiles"
        Icon={<Icon name={ICONS.USERS} color={iconColor} size={20} />}
        value={counts?.total ?? '—'}
        loading={loading}
      />
      <AudiencesStatsCard
        title="Registration Rate"
        Icon={<Icon name={ICONS.ATTENDEE} color={iconColor} size={20} />}
        value={counts ? formatRate(counts.registered, counts.total) : '—'}
        loading={loading}
      />
      <AudiencesStatsCard
        title="Attendance Rate"
        Icon={<Icon name={ICONS.RESEND_EMAIL} color={iconColor} size={20} />}
        value={counts ? formatRate(counts.attended, counts.registered) : '—'}
        loading={loading}
      />
      <AudiencesStatsCard
        title="Engagement Score"
        Icon={<Icon name={ICONS.CLICK} color={iconColor} size={20} />}
        value={'Coming soon'}
        loading={false}
      />
    </Container>
  );
};

export default AudiencesStatsRow;
